import { I18N } from './i18n/i18n';
export function getCondition(
    xCategory: number,
    xDiscountPercent: any,
    xDiscountAmount: any,
    xRequestedAmount: any,
    locale: string
    ): string {
    if (locale === I18N.EI18nLocale.Zn) {
        switch (xCategory) {
            case 1:
                return '立减' + xDiscountPercent + '%';
            case 2:
                return '立减' + xDiscountAmount;
            case 3:
                return '满' + xRequestedAmount + '减' + xDiscountPercent;
            case 4:
                return '满' + xRequestedAmount + '减' + xDiscountAmount;
            default:
                return '';
        }
    } else if (locale === I18N.EI18nLocale.En) {
        switch (xCategory) {
            case 1:
                return xDiscountPercent + '% OFF';
            case 2:
                return xDiscountAmount + ' OFF';
            case 3:
                return '$' + xDiscountPercent + ' OFF OVER $' + xRequestedAmount;
            case 4:
                return '$' + xRequestedAmount + ' OFF OVER $' + xRequestedAmount;
            default:
                return '';
        }
    } else {
        return '';
    }
}
